/**
 * Default site config for landing2-ui (UA flagship site).
 * Child apps (by/pl/am) override via their own app.config.ts from siteConfig.
 */
export default defineAppConfig({
  site: {
    orgName: 'Школа Біблії',                 // logo alt + brand name (UA default)
    // UA flagship uses a custom designed logo file (NOT the dynamic wordmark).
    // Locale sites (by/pl/am) omit `logo` and set `logoLines` → rendered by LogoMark.
    logo: '/images/logo/logo.svg',
    logoFooter: '/images/logo/logo-footer.svg',
    // Flagship multi-country site: geo-detect visitor phone code, fall back to
    // defaultCountryIso. Locale sites MUST set geoDetect:false EXPLICITLY — app.config
    // deep-merges across layers, so omitting it here would inherit this true.
    geoDetect: true,
    defaultCountryIso: 'ua',                 // phone default (dial code derived via findPhoneCodeByIsoCode)
    phone: '0 800 30 20 20',
    phoneTel: '0800302020',
    email: 'shkolabiblii@gmail.com',
    supportUrl: 'https://angel.hope.ua/proekt-shkola-bibliyi/' as string | null,
    // socialLinks intentionally NOT set here — Nuxt merges arrays across layers,
    // so child apps would end up with base + their own combined. Fallback UA links
    // live in LayoutFooterFooterMain.vue instead.
  },
})
